export default __webpack_public_path__ + "static/media/management.a52f9164.svg";